export default __webpack_public_path__ + "static/media/twitterLanding.8dacdf30.svg";